<cb-dialog dialogHeading="{{getDialogHeader()}}">
    <form class="flex-col" #standardPlanForm="ngForm">
        <mat-form-field [class.no-line]="isView()">
            <mat-label>Plan Name</mat-label>
            <input
                matInput
                type="text"
                name="planName"
                required
                [(ngModel)]="data.plan.name"
                [disabled]="isView()"
            />
        </mat-form-field>
        <mat-form-field [class.no-line]="isView()">
            <mat-label>Plan Description</mat-label>
            <textarea
                #description
                matInput
                type="text"
                name="description"
                [maxlength]="1000"
                [(ngModel)]="data.plan.description"
                [disabled]="isView()"
            >
            </textarea>
            @if (isEdit()) {
            <mat-hint align="end">{{ description.value.length }} / 1000 </mat-hint>
            }
        </mat-form-field>
        @if (data.plan && data.plan.stylesWithUrl && !isAdd()) {
        <div class="image-tabs">
            <mat-tab-group>
                @for (style of data.plan.stylesWithUrl; track style) {
                <mat-tab label="{{style.name}}">
                    <div class="flex-row flex">
                        <img
                            #planImage
                            mat-card-image
                            src="{{style.url}}?w=600&h=400&scale=canvas"
                            cbHandleInvalidImage
                            [height]="400"
                            [width]="600"
                            alt="Plan Image"
                        />
                        <div class="bottom-right end-center flex-row">
                            @if (!style.isPlaceHolderImage) {
                            <button
                                mat-raised-button
                                (click)="viewImage(style)"
                                class="button-right-8px"
                            >
                                <mat-icon>search</mat-icon>
                                &nbsp;View Image
                            </button>
                            } @if (isEdit() && !style.isPlaceHolderImage) {
                            <button
                                mat-raised-button
                                class="button-right-8px"
                                (click)="uploadImage(style)"
                            >
                                <mat-icon>cloud_upload</mat-icon>
                                &nbsp;Change Image
                            </button>
                            } @if (isEdit() && style.isPlaceHolderImage) {
                            <button
                                mat-raised-button
                                class="button-right-8px"
                                (click)="uploadImage(style)"
                            >
                                <mat-icon>cloud_upload</mat-icon>
                                &nbsp;Upload Image
                            </button>
                            } @if (isEdit() && !style.isPlaceHolderImage) {
                            <button
                                mat-raised-button
                                class="button-right-8px"
                                (click)="deleteImage(style)"
                            >
                                <mat-icon>delete</mat-icon>
                                &nbsp;Delete Image
                            </button>
                            }
                        </div>
                    </div>
                </mat-tab>
                }
            </mat-tab-group>
        </div>
        }
        <mat-tab-group mat-stretch-tabs="false">
            <mat-tab label="Plan Details">
                <div class="flex-row flex">
                    @if (isView()) {
                    <cb-standard-plan-details-view
                        class="flex"
                        [plan]="data.plan"
                    ></cb-standard-plan-details-view>
                    } @if (isEdit() || isAdd()) {
                    <cb-standard-plan-details-edit class="flex" [plan]="data.plan">
                    </cb-standard-plan-details-edit>
                    }
                </div>
            </mat-tab>
            @if (data.plan && data.addressRegions && data.plan.planCosts ) {
            <mat-tab label="Costs">
                <div class="flex-row flex">
                    <cb-standard-plan-costs
                        class="flex"
                        [plan]="data.plan"
                        [addressRegions]="data.addressRegions"
                        [formMode]="data.formMode"
                    ></cb-standard-plan-costs>
                </div>
            </mat-tab>
            }
        </mat-tab-group>
    </form>
    <div actions class="flex flex-row">
        @if (isView()) {
        <button mat-raised-button (click)="duplicate()">Duplicate</button>
        } @if (isEdit()) {
        <button mat-raised-button (click)="deleteStandardPlan()">Delete</button>
        }
        <div class="flex"></div>
        @if (isView()) {
        <button mat-raised-button (click)="edit()">Edit</button>
        } @if (isView()) {
        <button mat-raised-button (click)="close()">Close</button>
        } @if (isEdit() || isAdd()) {
        <button
            [disabled]=" (!standardPlanForm.dirty && isEdit()) || !standardPlanForm.valid"
            mat-raised-button
            (click)="save()"
        >
            Save
        </button>
        } @if (isEdit() || isAdd()) {
        <button mat-raised-button (click)="cancel()">Cancel</button>
        }
    </div>
</cb-dialog>
